import "../plugins/templates";
import MapPlaces from "../maps/mapPlaces";
import 'bootstrap-slider/dist/bootstrap-slider';

window.lawyerSearch = {};

(function () {

    lawyerSearch = new MapPlaces({
        renderListEntry: hbs.templates.lawyerSearch.resultListEntry,
        renderMapsInfoBox: hbs.templates.lawyerSearch.mapsInfoBox,
        citySearchSelector: '#lawyerSearchCity',
        place:{
            latKey: 'lat',
            lngKey: 'lng',
            markerTitleKey: 'name'
        }
    });

    var $lawyerSearchForm = $('#lawyerSearchForm');
    var $lawyerSearchName = $('#lawyerSearchName');
    var $lawyerSearchCity = $('#lawyerSearchCity');
    var $lawyerSearchRadius = $('#lawyerSearchRadius');
    var $lawyerSearchCategory = $('#lawyerSearchCategory');
    var $lawyerSearchRadiusValueText = $('#lawyerSearchRadiusValueText');
    var prevCity = '';

    $lawyerSearchCity.keypress(submitByEnter);
    $lawyerSearchCity.on('change', submitSearchForm);
    $lawyerSearchName.keypress(submitByEnter);
    $lawyerSearchName.on('change', submitSearchForm);

    $lawyerSearchForm.on('submit', function (e) {
        e.preventDefault();
        lawyerSearch.getLocation($lawyerSearchCity.val(), function (data) {
            if(!data){
                return;
            }
            if($lawyerSearchCity.val() !== '' && prevCity !== $lawyerSearchCity.val()){
                lawyerSearch.centerMapAtLatLng(data);
            }
            prevCity = $lawyerSearchCity.val();

            var params = {
                "city": $lawyerSearchCity.val(),
                "radius": $lawyerSearchRadius.val(),
                "category": $lawyerSearchCategory.val(),
                "name": $lawyerSearchName.val(),
                "lat": data.lat,
                "lng": data.lng
            };
            $.post(apiUri, params, function (data) {
                lawyerSearch.setPlaces(data);
            }, 'json').fail(function (a, b, c) {
                console.log('fehler');
            });
        });

    });

    var radiusChangeTimeout = null;
    $lawyerSearchRadius.on('change', function (e) {
        $lawyerSearchRadiusValueText.text($lawyerSearchRadius.val());
        if(radiusChangeTimeout) {
            clearTimeout(radiusChangeTimeout);
        }
        radiusChangeTimeout = setTimeout(function () {
            $lawyerSearchForm.submit();
        }, 600);
    });
    $lawyerSearchCategory.on('change', function (e) {
        $lawyerSearchForm.submit();
    });


    $('.locate-icon').click(function () {
        lawyerSearch.navigatorLocate(function (cityName) {
            $lawyerSearchCity.val(cityName);
            $lawyerSearchForm.submit();
        });
    });

    function submitByEnter(e) {
        if (e.which === 13) {
            e.preventDefault();
            submitSearchForm();
        }
    }

    function submitSearchForm() {
        $lawyerSearchForm.submit();
    }
})();

